export default __webpack_public_path__ + "images/home-icon-e8015b.svg";